<template>
  <div class="radio-list" :class="schema.listClasses" :disabled="disabled">
    <label v-for="item in items" :key="item.value" :class="getItemCssClasses(item)">
      <input
        :id="getFieldID(schema)"
        v-attributes="'input'"
        :disabled="isItemDisabled(item)"
        :name="id"
        :value="getItemValue(item)"
        :checked="isItemChecked(item)"
        :class="schema.fieldClasses"
        :required="schema.required"
        type="radio"
        @click="onSelection(item)"
      >
      <span>{{ getItemName(item) }}</span>
    </label>
  </div>
</template>

<script>
  // TODO extends vue-form-generator/src/fields/core/fieldRadios
  // eslint-disable-next-line import/no-extraneous-dependencies
  import VueFormGenerator from 'vue-form-generator';

  export default {
    mixins: [
      VueFormGenerator.component.components.formGroup.components.fieldRadios,
    ],
    methods: {
      getItemCssClasses(item) {
        return {
          'is-checked': this.isItemChecked(item),
          'is-disabled': this.isItemDisabled(item),
          'is-correct': item.correct,
          'is-error': item.error,
        };
      },
    },
  };
</script>
